export enum TabsDetailsLabels {
    USER_DETAILS = "User Details",
    PUSH_NOTIFICATION_TOKEN = "Push Notification Token",
    PUSH_NOTIFICATIONS = "Push Notifications",
    VERIFY_USER = "Verify user",
}
